<!-- <div class="hiddd" id="smoothid"></div> -->
@if(isBrowser()) {
<app-header></app-header>
@switch (mediaService.media()) {
@case ('xs') {
<ng-container *ngTemplateOutlet="modexssm"></ng-container>
}
@case ('sm') {
<ng-container *ngTemplateOutlet="modexssm"></ng-container>
}
@case ('md') {
<ng-container *ngTemplateOutlet="modexssm"></ng-container>
}
@default {
<ng-container *ngTemplateOutlet="modelgxl"></ng-container>
}
}
<footer></footer>
}

<ng-template #modexssm>
    <div class="section1-mobile">
        <clever-flugfilter [mode]="'ibeoffers'" [type]="realparams()?.productType" [israiltravel]="realparams()?.israiltravel">
        </clever-flugfilter>
        @if(showSmallHeader()) {
        <ng-container *ngTemplateOutlet="filterzonefixed"></ng-container>
        }
        <ng-container *ngTemplateOutlet="filterzone"></ng-container>
    </div>

    <!-- <div class="section2-mobile">
        <ng-container *ngTemplateOutlet="headercard"></ng-container>
        <ng-container *ngTemplateOutlet="pricecalendarmobile"></ng-container>
    </div> -->

    <div class="section2-mobile">
        <ng-container *ngTemplateOutlet="resultSectionMobile"></ng-container>
    </div>
</ng-template>

<ng-template #filterzone>
    <div class="extra-wrapper">
        <ng-container *ngTemplateOutlet="filterbtns"></ng-container>
    </div>
</ng-template>

<ng-template #filterzonefixed>
    <div class="extra-wrapper fixedtotop mat-elevation-z1">
        <div class="fixedtotopbody">
            <ng-container *ngTemplateOutlet="filterbtns"></ng-container>
        </div>
    </div>
</ng-template>

<ng-template #modelgxl>
    <div class="offers-wrapper">
        <div class="offers-body">
            <div class="section1">
                <clever-flugfilter [mode]="'ibeoffers'" [type]="realparams()?.productType" class="w100"
                    [israiltravel]="realparams()?.israiltravel"></clever-flugfilter>
                <clever-flugextrafilter [mode]="'ibeoffers'" [type]="realparams()?.productType" class="w100">
                </clever-flugextrafilter>
            </div>
            <div class="section2">
                <ng-container *ngTemplateOutlet="resultSection"></ng-container>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #resultSection>
    <div class="sortby-card">
        <div class="filterflex">
            <div class="resultcountwrapper">
                @if(loading()) {
                <ng-container *ngTemplateOutlet="myloadinghead"></ng-container>
                } @else {
                <span class="resultcount">{{totalResultCount()}}</span>
                <span class="resultcounttext">{{totalResultCount() === 1 ? 'Angebot ' :
                    'Angebote'}} gefunden</span>
                }
            </div>
            <ng-container *ngTemplateOutlet="header"></ng-container>
        </div>
    </div>
    <div class="content-wrapper">
        <div class="extratopsection">
            <clever-selectedfilters style="width: calc(100% - 200px)" [mode]="'ibeoffers'"
                [type]="realparams()?.productType"></clever-selectedfilters>
            @if(showErsteAngebotButton()) {
            <button class="zrkbtn" (click)="backToFirstAngebots()" matRipple>
                Zurück zum ersten Angebot
            </button>
            }
        </div>
        @if(loading()) {
        <ng-container *ngTemplateOutlet="myloading"></ng-container>
        } @else {
        @if(tmp_offers()?.offerList?.length > 0) {
        <div class="resultWrapper">
            @for (offer of tmp_offers()?.offerList;let k = $index; track $index) {
            @if(!offer.invalide) {
            <ng-container class="w100" *ngTemplateOutlet="offercardtmp context:{offer:offer}">
            </ng-container>
            }
            @if(k === 3){
            <div class="nodata-wrapper mb1">
                <callcenterusers [partner]="currentpartner" class="w100"></callcenterusers>
            </div>
            }
            }
        </div>
        <div class="more-wrapper">
            @if(loadingmore()) {
            <ng-container *ngTemplateOutlet="myloadingmore"></ng-container>
            } @else {
            @if((start() + limit()) < totalResultCount()) { <button class="showmore" (click)="loadingMoreManualy()"
                matRipple>
                <span>MEHR ANZEIGEN</span>
                </button>
                }
                }
        </div>
        } @else {
        <ng-container *ngTemplateOutlet="keineangebotfinden"></ng-container>
        }
        }
    </div>
</ng-template>

<ng-template #resultSectionMobile>
    @if(loading()) {
    <ng-container *ngTemplateOutlet="myloading"></ng-container>
    } @else {
    @if(tmp_offers()?.offerList?.length > 0) {
    <div class="filterflex-mobile">
        <div class="resultcountwrapper-mobile">
            <span class="resultcount">{{totalResultCount()}}</span>
            <span class="resultcounttext">{{totalResultCount() === 1 ? 'Angebot ' :
                'Angebote'}} gefunden</span>
        </div>
    </div>
    <div class="content-wrappermobile">
        <div class="resultWrapper-mobile">
            @for (offer of tmp_offers()?.offerList;let k = $index; track $index) {
            @if(!offer.invalide) {
            <ng-container class="w100" *ngTemplateOutlet="offercardtmp context:{offer:offer}">
            </ng-container>
            }
            @if(k ===3) {
            <div class="nodata-wrapper mb1">
                <callcenterusers [partner]="currentpartner" class="w100"></callcenterusers>
            </div>
            }
            }
        </div>
        <div class="more-wrapper">
            @if(loadingmore()) {
            <ng-container *ngTemplateOutlet="myloadingmore"></ng-container>
            } @else {
            @if((start() + limit()) < totalResultCount()) { <button class="showmore" (click)="loadingMoreManualy()"
                matRipple>
                <span>MEHR ANZEIGEN</span>
                </button>
                }
                }
        </div>
    </div>
    } @else {
    <ng-container *ngTemplateOutlet="keineangebotfinden"></ng-container>
    }
    }
</ng-template>

<ng-template #header>
    <div class="filter-wrapper">
        <span>Sortieren: </span>
        <button class="sortbtn" [matMenuTriggerFor]="menu" matRipple>
            <span>{{sortByname()}}</span>
            <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="sortby('price', 'Bester Preis')">Bester Preis</button>
            <button mat-menu-item (click)="sortby('fromDate', 'Datum')">Datum</button>
        </mat-menu>
    </div>
</ng-template>

<ng-template #offercardtmp let-offer="offer">
    <clever-flugcard [mode]="filtersData?.productType" [tmp_offer]="offer" class="w100"></clever-flugcard>
</ng-template>

<ng-template #keineangebotfinden>
    <div class="nodata-wrapper1">
        <span class="odata-text">Keine passenden Angebote gefunden.</span>
        <span class="odata-text1">
            Für die von Ihnen gewählte Kombination an Filtern sind derzeit keine Angebote verfügbar. Bitte ändern Sie
            Ihren Reisezeitraum, die Reisedauer oder passen Sie einen der Filter an. Es kann auch sein, dass die Reise,
            die Sie über eine Bestellnummer gesucht haben, nicht online buchbar ist, aber telefonisch verfügbar sein
            könnte.<br><br>
            Sollten Sie Unterstützung benötigen oder eine persönliche Beratung wünschen, stehen wir Ihnen gerne
            telefonisch zur Verfügung. Unsere Experten helfen Ihnen, passende Alternativen zu finden.<br><br>

            Wir freuen uns darauf, Ihnen weiterhelfen zu können!
        </span>
    </div>
    @if(currentpartner?.partnerid?.length > 0) {
    <div class="nodata-wrapper mt1">
        <callcenterusers [partner]="currentpartner" class="w100"></callcenterusers>
    </div>
    }
</ng-template>


<ng-template #filterbtns>
    <clever-selectedfilters [mode]="'ibeoffers'" [isDisabled]="true"></clever-selectedfilters>
    <button class="filter-btn mat-elevation-z1" #mdbuttonMobile="cdkOverlayOrigin" cdkOverlayOrigin
        (click)="openModalMobile()" matRipple>
        <mat-icon>filter_alt</mat-icon>
        <span class="ml3">Filter</span>
        <span class="f-badge">{{exnbr()}}</span>
    </button>
    <ng-container *ngTemplateOutlet="headerMobile"></ng-container>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="mdbuttonMobile"
        [cdkConnectedOverlayFlexibleDimensions]="true" [cdkConnectedOverlayOpen]="showModal()"
        [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="closeModalMobile()">
        <ng-container *ngTemplateOutlet="extrafilters"></ng-container>
    </ng-template>
</ng-template>

<ng-template #headerMobile>
    <div class="filter-wrapper-mobile mat-elevation-z1" [matMenuTriggerFor]="menu" matRipple>
        <button class="sortbtn-mobile">
            <mat-icon>sort</mat-icon>
            <span class="ml3">Sortieren</span>
        </button>
        <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="sortby('price', 'Bester Preis')">Bester Preis</button>
            <button mat-menu-item (click)="sortby('fromDate', 'Datum')">Datum</button>
        </mat-menu>
    </div>
</ng-template>

<ng-template #extrafilters>
    <div class="extrafilterswrapper-mobile">
        <div class="extrafilter-body">
            <div class="extrafilter-header">
                @if(loading()) {
                <div class="headload">
                    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
                </div>
                }
                <button class="empty">{{totalResultCount()}} Ang.</button>
                <span>Filter</span>
                <button (click)="take()" matRipple>
                    <mat-icon>close</mat-icon>
                </button>
            </div>
            <div class="extrafilter-content">
                @if(showErsteAngebotButton()) {
                <button class="zrkbtnmobile" (click)="backToFirstAngebots()" matRipple>
                    Zurück zum ersten Angebot
                </button>
                }
                <clever-selectedfilters [mode]="'ibeoffers'" [type]="realparams()?.productType"></clever-selectedfilters>
                <clever-flugextrafilter [mode]="'ibeoffers'" [type]="realparams()?.productType" class="w100">
                </clever-flugextrafilter>
            </div>
            <div class="extrafilter-footer">
                <button class="ubbtn" (click)="take()">ÜBERNEHMEN</button>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #myloadingmore>
    <mat-spinner diameter="20"></mat-spinner>
</ng-template>

<ng-template #myloading>
    <div style="display: flex;align-items: center;justify-content: center;flex-direction: column;width: 100%;">
        <div
            style="display: flex;flex-direction: column;width: 100%;border: 1px solid #5454542e;margin-top:.5rem;border-radius: .3rem;padding: .5rem;">
            <div style="width:80%;height:15px; border-radius: .3rem;" class="skeleton"></div>
            <div style="width:60%;height:15px; border-radius: .3rem;margin-top: .5rem;" class="skeleton"></div>
            <div style="width:20%;height:15px; border-radius: .3rem;margin-top: 3rem;" class="skeleton"></div>
        </div>
        <div
            style="display: flex;flex-direction: column;width: 100%;border: 1px solid #5454542e;margin-top:.5rem;border-radius: .3rem;padding: .5rem;">
            <div style="width:80%;height:15px; border-radius: .3rem;" class="skeleton"></div>
            <div style="width:60%;height:15px; border-radius: .3rem;margin-top: .5rem;" class="skeleton"></div>
            <div style="width:20%;height:15px; border-radius: .3rem;margin-top: 3rem;" class="skeleton"></div>
        </div>
        <div
            style="display: flex;flex-direction: column;width: 100%;border: 1px solid #5454542e;margin-top:.5rem;border-radius: .3rem;padding:.5rem;">
            <div style="width:80%;height:15px; border-radius: .3rem;" class="skeleton"></div>
            <div style="width:60%;height:15px; border-radius: .3rem;margin-top: .5rem;" class="skeleton"></div>
            <div style="width:20%;height:15px; border-radius: .3rem;margin-top: 3rem;" class="skeleton"></div>
        </div>
        <div
            style="display: flex;flex-direction: column;width: 100%;border: 1px solid #5454542e;margin-top:.5rem;border-radius: .3rem;padding:.5rem;">
            <div style="width:80%;height:15px; border-radius: .3rem;" class="skeleton"></div>
            <div style="width:60%;height:15px; border-radius: .3rem;margin-top: .5rem;" class="skeleton"></div>
            <div style="width:20%;height:15px; border-radius: .3rem;margin-top: 3rem;" class="skeleton"></div>
        </div>
        <div
            style="display: flex;flex-direction: column;width: 100%;border: 1px solid #5454542e;margin-top:.5rem;border-radius: .3rem;padding:.5rem;">
            <div style="width:80%;height:15px; border-radius: .3rem;" class="skeleton"></div>
            <div style="width:60%;height:15px; border-radius: .3rem;margin-top: .5rem;" class="skeleton"></div>
            <div style="width:20%;height:15px; border-radius: .3rem;margin-top: 3rem;" class="skeleton"></div>
        </div>
    </div>
</ng-template>

<ng-template #myloadingp>
    <div style="display: flex;flex-direction: column;width: 100%;margin-top:.5rem;padding:.5rem;">
        <div style="width:100%;height:15px; border-radius: .3rem;" class="skeleton"></div>
        <div style="width:100%;height:15px; border-radius: .3rem;margin-top: .5rem;" class="skeleton"></div>
        <div style="width:100%;height:15px; border-radius: .3rem;margin-top: 3rem;" class="skeleton"></div>
    </div>
</ng-template>

<ng-template #myloadinghead>
    <div style="display: flex;flex-direction: column;width: 50%;margin-top:.5rem;padding:.5rem;">
        <div style="width:100%;height:15px; border-radius: .3rem;" class="skeleton"></div>
    </div>
</ng-template>